module.exports = __webpack_public_path__ + "static/media/15.6b41e09d.gif";